module.exports = __webpack_public_path__ + "static/media/action-animal-bronco-bucking.d746989e.jpg";